<template>
  <div>
    <slot :name="name" v-bind="{ name, value, setValue }">
      <data-input
        v-bind="{ ...$attrs, ...$props }"
        :dataType="dataType"
        v-model="value"
        :hint="hint"
        v-on="$listeners"
        :disabled="canBeDisabled && disabled"
        @change="emitOnCustom"
      ></data-input>
    </slot>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify';

import DataInput from '@/components/DataInput';

export default {
  /**
   * The input was isolated to skip getting value from settings when slot is used, e.g. logo upload input.
   */
  name: 'AdminInputRowWrapper',
  components: {
    DataInput,
  },
  props: {
    dataType: {
      type: Object,
      default: () => {},
    },
    hint: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    storeSubproperty: {
      type: String,
      default: 'settingsValues',
    },
    valueSubproperty: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canBeDisabled: {
      type: Boolean,
      default: true,
    },
    isCustom: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    value: undefined,
  }),
  computed: {
    settingsValue: get('admin/:storeSubproperty@:name@:valueSubproperty'),
  },
  watch: {
    settingsValue: {
      immediate: true,
      deep: true,
      handler(nV) {
        this.value = nV;
        if (this.isCustom) {
          this.emitOnCustom(nV);
        }
      },
    },
  },
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    async editSingleSettingHandler(value) {
      if (value === this.settingsValue) {
        return;
      }
      await this.editSingleSetting({
        key: this.name,
        body: {
          value,
        },
      });
    },
    async save() {
      if (this.isCustom) {
        return;
      }
      try {
        this.$root.$emit('adminSavingON');
        await this.editSingleSettingHandler(this.value);
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
        this.$root.$emit('adminSavingOFF');
      } catch (error) {
        this.$root.$emit('adminSavingOFF');
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.settingChangeFailed'),
        });
        console.log(error);
      }
    },
    emitOnCustom(value) {
      this.$emit('setPayloadValue', { value, name: this.name, subproperty: this.valueSubproperty });
    },
    setValue(value) {
      this.value = value;
    },
  },
};
</script>

<style lang="scss" scoped></style>
